import ApiBase from '../ApiBase';

class Notifications extends ApiBase {
    route = '/comms/notifications';
}

export default new Notifications();
